import type { JSX } from 'react';
import { Box, Button, ButtonRow, Card, Heading } from '@ksyos/design-system';
import { orderBy } from 'lodash';
import type { ProcessActionButtonItem } from './processActionButtonItem';

type ProcessActionButtonRowProps = Readonly<{
    buttonItems: ProcessActionButtonItem[];
}>;

export function ProcessActionButtonRow(props: ProcessActionButtonRowProps): JSX.Element | null {
    const { buttonItems } = props;

    if (!buttonItems.length) {
        return null;
    }

    const orderedButtonItems = orderBy(props.buttonItems, ['processTaskCreatedDatetime'], ['desc']);

    return (
        <Card>
            <Card.Body>
                <Box
                    display="flex"
                    gap={36}
                    paddingLeft={[8, null, null, 12]}
                >
                    <Heading
                        size="medium"
                        sx={{ alignSelf: 'auto', flex: '0 0 auto', marginTop: '6px' }}
                    >
                        Ga verder met
                    </Heading>
                    <ButtonRow
                        isStackedBelowSmall={true}
                        justify="right"
                        sx={{ justifyContent: 'flex-start' }}
                    >
                        {orderedButtonItems.map((buttonItem) => (
                            <Button
                                key={buttonItem.key}
                                onClick={buttonItem.onClick}
                                variant={buttonItem.processTaskCreatedDatetime ? undefined : 'outline'}
                            >
                                {buttonItem.label}
                            </Button>
                        ))}
                    </ButtonRow>
                </Box>
            </Card.Body>
        </Card>
    );
}
